/// <reference path="Utilities/_reference.ts" />

module YVR.CriticalMessage {
	// Dependencies
	import cache = YVR.Utilities.Cache;

	// Class names
	const classes = {
		wrapperBlur: 'yvr-wrapper--blur'
	};

	// Cache jQuery elements
	const elements = {
		block: $('.yvr-modal--alert'),
		wrapper: $('.yvr-wrapper')
	};


	/**
	 * Initialise the modal.
	 */
	function main() {
		addHeaderPadding();

		if (elements.block.length) {
			checkCache();
			eventBindings();
		}
	}


	/**
	 * Add top padding to the header.
	 */
	function addHeaderPadding() {
		if ($('.yvr-critical-message').length) {
			$('.yvr-header').addClass('yvr-header--critical-message');
		}
	}


	/**
	 * Create the cache key for saving modal dismissals.
	 */
	function createCacheKey() {
		const id = elements.block.data('message-id').replace(/[{\-}]/g, '');

		return `Critical_Message_${id}`;
	}


	/**
	 * Check to see if the user has dismissed this particular modal before.
	 */
	function checkCache() {
		const key = createCacheKey();

		if (!Modernizr.localstorage || cache.getItem(key)) {
			elements.block.remove();
		} else {
			elements.block.addClass('yvr-modal--active');
			elements.wrapper.addClass(classes.wrapperBlur);
		}
	}


	/**
	 * Initialise the event bindings for the modal.
	 */
	function eventBindings() {
		setCloseButton();
		setDetailsButton();
	}


	/**
	 * When a user clicks on the close button, remember to dismiss the modal
	 * for next time.
	 */
	function setCloseButton() {
		elements.block.on('click', '.yvr-modal__close', e => {
			e.preventDefault();

			elements.block.remove();
			elements.wrapper.removeClass(classes.wrapperBlur);

			setCache();
		});
	}


	/**
	 * When a user clicks on the details button, redirect to the details page
	 * but remember to dismiss the modal for next time.
	 */
	function setDetailsButton() {
		elements.block.on('click', '.yvr-modal__details', function (e) {
			e.preventDefault();

			setCache();

			const href = $(this).attr('href');

			if (href) {
				window.location.href = href;
			}
		});
	}


	/**
	 * Set the modal to be dismissed.
	 */
	function setCache() {
		const key = createCacheKey();

		cache.setItem(key, true, 60 * 24 * 7);
	}


	// Kick it
	main();
}
